module.exports = __webpack_public_path__ + "static/banner-mobile-4a1d258fd0960883016e10fab1904971.jpg";